/**
 * Created by ChrisMuto on 7/7/17.
 */
import { isNil } from "lodash";
import { getImageById } from "../images/selectors";

export function getAudienceById(entities, audienceId) {
    const { audiences } = entities;
    if (isNil(audiences)) {
        return null;
    }
    const audience = audiences[audienceId];
    if (isNil(audience)) return null;
    const iconImage = getImageById(entities, audience.iconImage);
    const segments = audience.segments
        ? audience.segments.reduce((acc, segmentId) => {
              const segment = getAudienceSegmentbyId(entities, segmentId);
              if (segment) {
                  acc.push(segment);
              }
              return acc;
          }, [])
        : [];
    return {
        ...audience,
        iconImage,
        segments
    };
}

export function getAudienceSegmentbyId(entities, audienceSegmentId) {
    const { segments } = entities;
    if (isNil(segments)) {
        return null;
    }
    return segments[audienceSegmentId];
}

export function getWevoAudience(entities, wevoAudienceId) {
    const { wevoAudiences } = entities;
    if (isNil(wevoAudiences)) {
        return null;
    }
    const wevoAudience = wevoAudiences[wevoAudienceId];
    if (isNil(wevoAudience)) return null;
    const iconImage = getImageById(entities, wevoAudience.iconImage);
    const segments = wevoAudience.segments
        ? wevoAudience.segments.reduce((acc, wevoSegmentId) => {
              const segment = getWevoAudienceSegment(entities, wevoSegmentId);
              if (segment) {
                  acc.push(segment);
              }
              return acc;
          }, [])
        : [];
    return {
        ...wevoAudience,
        iconImage,
        segments
    };
}

export function getWevoAudienceSegment(entities, wevoSegmentId) {
    const { wevoSegments } = entities;
    if (isNil(wevoSegments)) {
        return null;
    }
    const wevoSegment = wevoSegments[wevoSegmentId];
    if (!wevoSegment) return null;
    return {
        ...wevoSegment,
        segment: getAudienceSegmentbyId(entities, wevoSegment.segment)
    };
}



// WEBPACK FOOTER //
// ./src/modules/audiences/selectors.js